import React, { useContext } from "react";
import Profile from "../components/userActions/Profile";
import { MainContext } from "../context/MainContext";

export default function UserProfile() {
  const { user } = useContext(MainContext);
  return <Profile user={user} />
}